import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocalShippingOutlined,
  LocationOnOutlined,
  InventoryOutlined,
  CalendarTodayOutlined,
  InfoOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetCollectionDetailQuery } from "store/services/collectionApi";

const CollectionInfoScreen = ({ collectionId }) => {

  const breadcrumbs = [{ title: "Collection Info" }];

  // RTK Query
  const { data: fulfillmentDetail, isLoading: loadingFulfillmentDetail, error,
  } = useGetCollectionDetailQuery(collectionId);

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingFulfillmentDetail}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingFulfillmentDetail ? (
          <Box padding={3}>
            <Typography variant="h6">
              {fulfillmentDetail?.shipment_name || "Shipment Details"}
            </Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalShippingOutlined color="primary" />}
                  title="Collection ID"
                  subtitle={fulfillmentDetail?.fulfillment_id || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Destination Location"
                  subtitle={fulfillmentDetail?.destination_location || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Items to Fulfill"
                  subtitle={fulfillmentDetail?.items_to_fulfill || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Shipment Date"
                  subtitle={fulfillmentDetail?.shipment_date || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InfoOutlined color="primary" />}
                  title="Carrier"
                  subtitle={fulfillmentDetail?.carrier || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={fulfillmentDetail?.status === "active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CollectionInfoScreen;
